<template>
  <div class="homeMian" :style="{ backgroundImage: 'url(' + bgImg + ')' }">
    <swiper
      v-if="templata.length"
      class="mySwiper"
      ref="mySwiper"
      :options="swiperOptions"
    >
      <swiper-slide
        class="mySwiperItem"
        v-for="item in templata"
        :key="item.model_id"
      >
        <component :is="item.id" :appInfo="item.appList"></component>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
import { selectDeskyopInfoBySnModel } from "@/utils/api";

export default {
  name: "HomeView",
  data() {
    return {
      templata: [],
      sn: "",
      model: "",
      bgImg: "",
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination",
          bulletClass: "my-bullet",
          bulletActiveClass: "my-bullet-active",
        },
      },
    };
  },
  methods: {},
  async created() {
    // console.log(this.$route.query);
    this.sn = this.$route.query.sn.substring(0, 4);
    this.model = this.$route.query.model;
    let data = {
      sn: this.sn,
      model: this.model,
    };
    // eslint-disable-next-line no-unused-vars
    const res = await selectDeskyopInfoBySnModel(data).catch((err) => {});
    if (!res) return false;
    let templata = res.data.templata;
    this.bgImg = res.data.desk_picture;
    templata.forEach((item) => {
      item.id = () => import("@/components/muban/Muban" + item.model_num);
    });
    this.templata = templata;
  },
  mounted() {},
};
</script>

<style scoped>
.homeMian {
  width: 100%;
  height: 100vh;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.mySwiper {
  width: 100%;
  height: 100%;
}
.mySwiperItem {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.swiper-pagination {
  bottom: 5vh;
}
.mySwiper >>> .my-bullet {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: rgb(160, 160, 160);
  margin-left: 10px;
}
.mySwiper >>> .my-bullet-active {
  background: rgb(0, 180, 0);
}
</style>
